import { ITooltipComp, ITooltipParams } from '@ag-grid-community/core';
import { tooltipStyles } from '../../components/custom-styles/zero-tooltip';

export class CreditProfileLegendTooltipComponent implements ITooltipComp {
  init(params: ITooltipParams) {
    // Prevents the tooltip from popping up in the column sidebar
    if (params.location === 'header') {
      this.content = document.createElement('div');

      // Set Tooltip styles to match zero-tooltip styles to be consistent
      this.content.style.cssText = tooltipStyles;

      const legendTitle = document.createElement('span');
      legendTitle.innerHTML = 'Credit Profile Definitions';
      legendTitle.style.fontWeight = 'bold';
      legendTitle.style.textDecoration = 'underline';

      this.content.appendChild(legendTitle);
      this.content.appendChild(document.createElement('br'));
      this.getSpanForText('"PL": Project Lien');
      this.getSpanForText('"PG from IG": Parental Guarantee from Investment-Grade Entity');
      this.getSpanForText('"PG from Non-IG": Parental Guarantee from Non Investment-Grade Entity');
      this.getSpanForText('"IG": Investment Grade Entity');
      this.getSpanForText('"$XXXX": Letter of Credit');
    } else {
      this.content = document.createElement('div');
      this.content.style.display = 'none';
    }
  }

  content: HTMLElement;

  getGui(): HTMLElement {
    return this.content;
  }

  refresh(): boolean {
    return false;
  }

  /**
   * Helper Function for displaying the Credit Profile Text
   *
   * @private
   */
  private getSpanForText(txt: string) {
    const text = document.createElement('span');
    text.innerHTML = txt;
    this.content.appendChild(document.createElement('br'));
    this.content.appendChild(text);
    this.content.appendChild(document.createElement('br'));
  }
}
